<template>
  <div class="container pb-16">
    <navigation-drawer :titles="'ویرایش تنظیمات'"/>
    <div class="row">
      <div class="col-md-6">
        <div class="mr-2 mb-2 font-16">نام</div>
        <div>
          <v-text-field
              v-model="DisplayName"
              readonly
              solo
              background-color="white"
              flat
              class="rounded-lg"
          >
          </v-text-field>
        </div>
        <div class="mr-2 mb-2 font-16">مقدار</div>
        <div>
          <v-text-field
              type="number"
              v-model="Value"
              solo
              background-color="white"
              flat
              class="rounded-lg"
          >
          </v-text-field>
        </div>
        <div class="mr-2 mb-2 font-16">واپسین به روز رسانی</div>
        <div>
          <v-text-field
              readonly
              v-model="ModifiedDate"
              solo
              background-color="white"
              flat
              class="rounded-lg"
          >
          </v-text-field>
        </div>
      </div>
      <div class="col-12">
        <v-btn color="primary" class="rounded-lg " large
               @click="editSetting">
          <span class="font16px">ویرایش</span>
        </v-btn>
      </div>
    </div>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false"
          >
            <i class="fas fa-times font-16 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>


import NavigationDrawer from "@/Admin/components/navigationDrawer";
export default {
  name: "editSetting",
  components: {NavigationDrawer},
  data: () => ({
    showResultDialog: false,
    dialogResult: null,
    showLoaderDialog: false,
    DisplayName: null,
    Value: null,
    ModifiedDate: null
  }),
  mounted() {
    this.$convertFarsiNumber()
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/Automation'})
    }
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditSetting?settingid=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.DisplayName = json.DisplayName
            this.Value = json.Value
            this.ModifiedDate = this.$convertDate(json.ModifiedDate)

          })
          .catch(error => console.log('error', error));
    },
    editSetting() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("Value", this.Value);
      urlencoded.append("ModifiedDate", this.ModifiedDate);
      urlencoded.append("SettingID", this.$route.query.id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditSetting", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
            this.$router.push({path: 'appSetting'})
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
